// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__2XQ5Y","content":"app_content__1V-xI"};